module.exports = __webpack_public_path__ + "static/media/music-alt.e5b23cc3.svg";